module.exports = __webpack_public_path__ + "static/img/logoYX.8621cb58.jpg";